import React from 'react';
import { Link } from 'react-router-dom';
import ennVitalLogo from '../assets/76332b8bb9abe1378a2e4e45b34bedce1d3ce572.png';

export const Logo = ({ 
  variant = 'default', 
  className = '',
  showTagline = true 
}) => {
  const getLogoSize = () => {
    switch (variant) {
      case 'compact':
        return 'h-8'; // Only height, let width be auto for proper aspect ratio
      case 'footer':
        return 'h-12';
      case 'full':
        return 'h-16'; // Larger size for the full logo
      default:
        return 'h-10';
    }
    
  };

  const getTaglineSize = () => {
    switch (variant) {
      case 'compact':
        return 'text-xs';
      case 'footer':
        return 'text-sm';
      case 'full':
        return 'text-base';
      default:
        return 'text-sm';
    }
  };

  // For the full logo that includes text, we don't need additional text
  const shouldShowText = variant !== 'compact' && variant !== 'full';

  return (
    <div className={`flex items-center space-x-3 ${className}`}>
      {/* EnnVital Logo */}
      <div className={`${getLogoSize()} relative flex-shrink-0`}>
        <img 
          src={ennVitalLogo} 
          alt="EnnVital - Psychiatric Services" 
          className="h-full w-auto object-contain drop-shadow-sm"
        />
      </div>

      {/* Tagline */}
      {shouldShowText && showTagline && (
        <div className="flex flex-col">
          <div className={`${getTaglineSize()} text-clinic-gray-600 leading-none font-medium`}>
            Comprehensive Psychiatric Care
          </div>
        </div>
      )}
    </div>
  );
};

export const LogoLink = ({ to = '/', ...props }) => {
  return (
    <Link to={to} className="hover:opacity-90 transition-opacity duration-200">
      <Logo {...props} />
    </Link>
  );
};

// Icon-only version
export const LogoIcon = ({ size = 'h-8', className = '' }) => {
  return (
    <div className={`${size} relative ${className}`}>
      <img 
        src={ennVitalLogo} 
        alt="EnnVital" 
        className="h-full w-auto object-contain drop-shadow-sm"
      />
    </div>
  );
};

// Navbar version
export const NavbarLogo = ({ className = '' }) => {
  return (
    <LogoLink 
      variant="full" 
      showTagline={false}
      className={className}
    />
  );
};

// Footer version
export const FooterLogo = ({ className = '' }) => {
  return (
    <Logo 
      variant="footer" 
      showTagline={true}
      className={className}
    />
  );
};
